import { useTranslation } from "react-i18next";

export default function SummaryPageLabels(props) {
  const { label, title, className, styles, isColon } = props;
  const { t } = useTranslation();
  return (
    <span className={className} style={styles}>
      {(label === "eConsentAgreementText" || label === "borrowerAuthorizationConsentText" || label === "consumerCreditConsentText") ? t(title) : t(label)}{isColon &&" : "}
    </span>
  );
}
